import { motion, useScroll, useSpring } from "framer-motion";
import { SPRING } from "@/lib/motionSystem";

/**
 * ScrollProgress — Thin gradient line at the top showing scroll progress.
 * Dora.run-style scroll indicator.
 */
export default function ScrollProgress() {
  const { scrollYProgress } = useScroll();
  const scaleX = useSpring(scrollYProgress, { ...SPRING.soft, restDelta: 0.001 });

  return (
    <motion.div
      className="fixed top-0 left-0 right-0 h-px z-[9999] origin-left"
      style={{
        scaleX,
        background: "linear-gradient(90deg, #6366f1, #06b6d4, #a855f7)",
      }}
    />
  );
}
